import ViewProductPromotion from "./ViewProductPromotion";

export default ViewProductPromotion;